import Clazz from '../common/Clazz';
import SymbolFactory from '../symbol/SymbolFactory';
import GeometryFactory from '../geometry/GeometryFactory';

/**
 * 渲染器基类
 */
export default class Renderer extends Clazz {
    /**
     * 初始化构造函数
     */
    constructor(options) {
        super(options);
        
        /**
         * 符号工厂
         * @type {object}
         */
        this._symbolFactory = SymbolFactory.getInstance();
        /**
         * 几何工厂
         * @type {object}
         */
        this._geometryFactory = GeometryFactory.getInstance();
    }

    /**
     * 获取常规的渲染符号
     * 抽象方法,必须在子类中重写此方法
     * @interface
     * @param {object} feature - 要素数据模型对象
     * @param {object} zoom    - 地图缩放级别
     * @return {object} - 根据数据模型创建的渲染符号
     */
    getSymbol(feature, zoom) {
        throw new Error(`${feature.type}要素对应Render未实现getSymbol方法`);
    }

    /**
     * 获取高亮时的渲染符号
     * 抽象方法,必须在子类中重写此方法
     * @interface
     * @param {object} feature - 要素数据模型对象
     * @param {object} zoom    - 地图缩放级别
     * @return {object} - 根据数据模型创建的渲染符号
     */
    getHighlightSymbol(feature, zoom) {
        throw new Error(`${feature.type}要素对应Render未实现getHighlightSymbol方法`);
    }
}
